'use client'
import { useTranslations } from 'next-intl'
import { BaseEmptyStateProps } from '../types'
import { BaseEmptyState } from '../BaseEmptyState'

export const EventEmptyState: React.FC<BaseEmptyStateProps> = (props) => {
  const t = useTranslations('emptyStates.events')

  return (
    <BaseEmptyState
      {...props}
      title={t('title')}
      description={t('description')}
      imageSrc="/emptyStates/new-product-illustration.svg"
      variant="base"
    />
  )
}
